module.exports = __webpack_public_path__ + "img/ve.ve2d66184.svg";